import type { Channel } from '@rp/contracts'
import { Button, Dialog } from '../../design'
import { PLATFORM_LABELS } from '../queue/labels'
import { SETTINGS_COPY } from './copy'

type DisconnectChannelDialogProps = {
  channel: Channel | null
  pending: boolean
  onCancel: () => void
  onConfirm: (channel: Channel) => void
}

export const DisconnectChannelDialog = ({ channel, pending, onCancel, onConfirm }: DisconnectChannelDialogProps) => (
  <Dialog
    open={channel !== null}
    title={SETTINGS_COPY.disconnectTitle}
    onClose={onCancel}
    tone="danger"
    edge="hatch"
    footer={
      <>
        <Button onClick={onCancel}>{SETTINGS_COPY.cancel}</Button>
        <Button
          variant="danger-solid"
          pending={pending}
          pendingLabel={SETTINGS_COPY.disconnecting}
          onClick={() => (channel === null ? undefined : onConfirm(channel))}
        >
          {SETTINGS_COPY.confirmDisconnect}
        </Button>
      </>
    }
  >
    {channel === null ? null : (
      <>
        <p className="measure">{SETTINGS_COPY.disconnectBody(channel.name, PLATFORM_LABELS[channel.platform])}</p>
        <p className="measure settings-hint">{SETTINGS_COPY.disconnectAfter}</p>
      </>
    )}
  </Dialog>
)
